import { buildRecipeCardProps } from "../utils/buildRecipeCardProps";
/**
 * Builds the "All Recipes" slider component, which aggregates recipes from all program meals.
 *
 * @param BuildAllRecipesSliderArgs
 * @returns BuildAllRecipesSliderReturn
 *
 */
export const buildAllRecipesSlider = ({ moduleConfig, programMealsWithRecipes, recipeAutoSelection, recipeHandlerProps_One, recipeImageBaseUrl, setAssignmentId, setIsAddDisabled, setMeals, setQuantity, store, }) => {
    let anyRecipesAvailable = false;
    const allRecipesSlider = programMealsWithRecipes.flatMap((pmwr) => {
        const recipesAvailable = pmwr.recipesForMeal.length > 0;
        if (!recipesAvailable)
            return [];
        anyRecipesAvailable = true;
        return pmwr.recipesForMeal.map((recipe) => {
            const cardProps = buildRecipeCardProps({
                moduleConfig,
                pmwr,
                recipe,
                recipeAutoSelection,
                recipeHandlerProps_One,
                recipeImageBaseUrl,
                setAssignmentId,
                setIsAddDisabled,
                setMeals,
                setQuantity,
                store,
            });
            return cardProps;
        });
    });
    allRecipesSlider.sort((a, b) => { var _a, _b; return ((_a = b === null || b === void 0 ? void 0 : b.availableQuantity) !== null && _a !== void 0 ? _a : 0) - ((_b = a === null || a === void 0 ? void 0 : a.availableQuantity) !== null && _b !== void 0 ? _b : 0); });
    return {
        allRecipesSlider,
        anyRecipesAvailable,
        programMealSliders: null,
    };
};
